<template>
  <div class="spnod-admin__form--container container pl-0 mx-0 d-flex flex-column">
    <b-form class="d-flex flex-column" @submit.stop.prevent>
      <b-form-input
        v-model="$v.form.name.$model"
        name="name"
        :state="validateState('name')"
        type="text"
        placeholder="Name"
        size="sm"
        class="mb-2"></b-form-input>
      <b-form-file
        class="mb-2"
        size="sm"
        type="file"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
        ref="fileInput"
        @change.prevent="handleUpload"></b-form-file>
      <Multiselect
        v-model="form.sharedWith"
        :options="options"
        :multiple="true"
        :close-on-select="false"
        placeholder="Share with"
        track-by="_id"
        label="name"
        :group-select="true"
        group-values="values"
        group-label="label"
        class="mb-2">
      </Multiselect>
      <b-form-textarea
        v-model="$v.form.description.$model"
        name="description"
        :state="validateState('description')"
        type="text"
        rows="3"
        placeholder="Description"
        size="sm"
        class="mb-2">
      </b-form-textarea>
      <p class="text-muted mb-2">All files will be viewable by your Nutritionist</p>
      <p class="text-muted mb-4">Max file size 10 MB</p>
      <b-form-group>
        <b-button
          class="spnod-admin__form--button"
          size="sm"
          type="submit"
          :disabled="isDisabled"
          v-b-modal="modals.upload._id">
          <p v-if="!isProcessing">Save</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
      </b-form-group>
    </b-form>

    <!--  Upload Modal  -->
    <Modal
      :_id="modals.upload._id"
      :message="modals.upload.message"
      @success="handleSubmit" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { Multiselect } from 'vue-multiselect'
import Modal from '../Notifications/Modal'

export default {
  name: 'FileUploadForm',
  components: { Multiselect, Modal },
  mixin: [validationMixin],
  data() {
    return {
      form: {
        name: '',
        description: '',
        files: null,
        sharedWith: []
      },
      modals: {
        upload: {
          _id: 'upload-modal',
          message: 'Are you sure you want to upload this file?'
        }
      },
      options: [],
      isProcessing: false
    }
  },
  computed: {
    ...mapGetters(['users', 'groups', 'getMyInfo']),
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some(obj => obj[1] === '')
      const tooLarge = this.form.files && this.form.files[0].size > 10000000
      return anyBlanks || this.$v.form.$anyError || this.form.sharedWith.length === 0 || tooLarge
    }
  },
  methods: {
    ...mapActions(['createFile', 'getGroups', 'getUsers', 'getMyUsers']),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleUpload(event) {
      // Data obj comes in diff based on event type
      if (event.type === 'drop') {
        this.form.files = event.dataTransfer.files
      } else {
        this.form.files = event.target.files
      }
    },
    handleSubmit: async function() {
      const formData = new FormData()

      for (let i = 0; i < this.form.files.length; i++) {
        formData.append('files', this.form.files[i])
      }

      // Comment & Clean
      const copy = this.form
      delete copy.files
      const json = JSON.stringify(copy)
      const blob = new Blob([json], {
        type: 'application/json'
      })
      formData.append('data', blob)

      this.isProcessing = true
      await this.createFile({ data: formData, name: this.form.name })
      this.isProcessing = false

      this.$router.push('/file')
    }
  },
  validations: {
    form: {
      name: { required },
      description: { required },
      file: { required }
    }
  },
  mounted: async function() {
    let groups, users

    if (this.getMyInfo.hasRoles) {
      // Fetch first thousand Users & Groups for multiselect
      await this.getGroups({ page: 1, pageSize: 10000 })
      await this.getUsers({ page: 1, pageSize: 10000 })
      users = JSON.parse(JSON.stringify(this.users))
      groups = JSON.parse(JSON.stringify(this.groups))
    } else {
      // Fetch users within scope
      await this.getMyUsers({})
      await this.getGroups({ page: 1, pageSize: 10000 })
      users = JSON.parse(JSON.stringify(this.users))
      groups = JSON.parse(JSON.stringify(this.groups))
      if (this.getMyInfo.nutritionist) users.data.push(this.getMyInfo.nutritionist.employee)
    }

    const userOptions = { label: 'Users', values: [] }
    if (users && users.data) {
      users.data.forEach(u => {
        userOptions.values.push({
          name: `${u.name} - ${u.email}`,
          _id: u._id,
          type: 'user'
        })
      })

      userOptions.values = userOptions.values.sort(function(a, b) {
        return a.name.localeCompare(b.name)
      })
    }

    const groupOptions = { label: 'Groups', values: [] }
    if (groups && groups.data) {
      groups.data.forEach(g => {
        groupOptions.values.push({
          name: g.name,
          _id: g._id,
          type: 'group'
        })
      })
    }

    this.options = [userOptions, groupOptions]
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/FIleUploadForm.vue?ff0df132